




































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import {
  IWebhook,
  IWebhookTriggerForm,
  IWebhookTriggerData,
  IWebhookSubscription
} from "@/models/webhooks";
import { ITemplateCategory } from "@/models/templates";

@Component({
  components: {
    "category-select-field": () =>
      import(
        "@/components/app/global/templates/templateFields/categorySelectField.vue"
      ),
    "webhook-category-triggers-selector": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookCategoryTriggersSelector.vue"
      )
  }
})
export default class ManageWebhookTriggerModal extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public webhookId!: IWebhook["id"];

  @Prop({ required: true })
  public categories!: ITemplateCategory[];

  @Prop({ default: null })
  public webhookTriggerData!: IWebhookTriggerData;

  @Prop({ default: () => [] })
  public disabledCategoryIds!: ITemplateCategory["id"][];

  // Data

  public form: IWebhookTriggerForm = {
    sync_category_id: _.get(this.categories, "[0].id", null),
    subscriptions: [
      {
        category_id: _.get(this.categories, "[0].id", null),
        hook_id: []
      }
    ] as IWebhookSubscription[]
  };
  public initialForm = {} as IWebhookTriggerForm;
  public isProcessing = false;

  public triggers = [];

  // Life-cycle methods

  public created() {
    if (this.isEdit) this.form = this.webhookTriggerData;
    else {
      const categoryId = _.get(
        _.filter(
          this.categories,
          (category: ITemplateCategory) =>
            !this.disabledCategoryIds.includes(category.id)
        ),
        "[0].id",
        null
      );

      this.form = {
        sync_category_id: categoryId,
        subscriptions: [
          {
            category_id: categoryId,
            hook_id: []
          }
        ]
      } as IWebhookTriggerForm;
    }
    this.initialForm = _.cloneDeep(this.form);
  }

  // Methods

  public async validateBeforeSubmit() {
    if (!this.canManageTrigger) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.updateWebhookCategoryTriggers();

      this.$store.dispatch("toast/show", {
        message: this.$t(
          this.isEdit
            ? "_sentence.webhooks.webhook_trigger_successfully_updated"
            : "_sentence.webhooks.webhook_trigger_successfully_created"
        )
      });

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public updateWebhookCategoryTriggers() {
    return this.$store.dispatch(
      `data/${DataModules.WEBHOOKS_TRIGGERS}/updateCategoryTriggers`,
      {
        id: this.webhookId,
        data: this.form
      }
    );
  }

  // Computed

  public get categoryHooks() {
    return _.filter(
      _.get(
        _.find(this.categories, ["id", this.form.sync_category_id]),
        "hooks",
        []
      ),
      hook => hook.webhookable
    );
  }

  public get isEdit() {
    return !_.isNull(this.webhookTriggerData);
  }

  public get title() {
    return this.isEdit
      ? this.$t("_.edit_webhook_trigger")
      : this.$t("_.create_webhook_trigger");
  }

  public get canManageTrigger() {
    return this.isEdit
      ? this.$userCan("update_webhook_subscription")
      : this.$userCan("create_webhook_subscription");
  }

  public get formIsDisabled() {
    return !this.canManageTrigger || this.isProcessing;
  }

  public get hasNoSelection() {
    if (this.isEdit) return false;

    return _.isEmpty(this.form.subscriptions);
  }
}
